var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4399 21.2701V18.345H12.5601V21.2701H15.4399ZM27.5 7.39508H0.5V9.85492H3.125V28.4399C3.12282 28.6429 3.16076 28.8444 3.23651 29.0327C3.31226 29.2209 3.42435 29.3924 3.56647 29.5373C3.70858 29.6822 3.87791 29.7977 4.0647 29.8771C4.25149 29.9565 4.45208 29.9982 4.65503 30H23.345C23.7503 29.9987 24.1386 29.8368 24.4249 29.5499C24.7125 29.2519 24.8738 28.8541 24.875 28.4399V9.85492H27.5V7.39508ZM22.46 27.54H5.55499V9.85492H22.46V27.54ZM22.1 2.46002H15.2151V0H12.7849V2.46002H5.89996V4.92004H22.1V2.46002Z",
    fill: "#ACCAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e355066451fa9f39b158127c3bbb8fea.svg";
export { ForwardRef as ReactComponent };